import React from 'react';
import TrackOrderPage from './pages/TrackOrder';
import CreateOrderPage from './pages/CreateOrder';
import FloatingContact from './components/FloatingContact';

const App: React.FC = () => {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';

  const page = (() => {
    if (path === '/create') return <CreateOrderPage />;

    const seg = path.split('/').filter(Boolean);
    if (seg.length === 1) return <TrackOrderPage customerName={decodeURIComponent(seg[0])} />;

    return (
      <div className="ot-not-found">
        <div className="ot-nf-inner">
          <i className="fas fa-clock ot-nf-icon"></i>
          <h1>Page Not Found</h1>
          <p>The page you're looking for doesn't exist.</p>
          <a href="https://on-time-store.com" className="ot-btn ot-btn-primary">
            <i className="fas fa-store"></i> Visit Store
          </a>
        </div>
      </div>
    );
  })();

  // Hide support widget on the internal employee page.
  const showContact = path !== '/create';

  return (
    <>
      {page}
      {showContact && <FloatingContact />}
    </>
  );
};

export default App;
